/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    declare var intlTelInputUtils;

    export function meevoPhoneNumberFormatFilter(appSettings: Meevo.Components.Common.IAppSettings): angular.IFilterService {
        const filter = (input: any, countryCode?: string) => {

            if (!input) {
                return "";
            }

            var phoneNumber: string = input;
            var format = intlTelInputUtils.numberFormat.INTERNATIONAL;
            var cultureCountryCallingCode = appSettings.APP_COUNTRIES[appSettings.APP_ISOCOUNTRYCODE].CountryCallingCode;
            if (Meevo.Model.Guard.isSomething(countryCode)) {
                if (phoneNumber[0] !== "+") {
                    phoneNumber = "+" + countryCode + input;
                }
                if (cultureCountryCallingCode == countryCode) {
                    format = intlTelInputUtils.numberFormat.NATIONAL;
                }
            }
            else {
                // default to US format for 10 digit numbers
                if (input[0] !== "+" && input.length === 10) {
                    phoneNumber = `+1${input}`;
                    if (cultureCountryCallingCode == "1") {
                        format = intlTelInputUtils.numberFormat.NATIONAL;
                    }
                }
            }

            return intlTelInputUtils.formatNumber(phoneNumber, null, format);
        };
        return filter;
    }

    meevoPhoneNumberFormatFilter.$inject = ["meevo.AppSettings"];

    angular.module("meevo.components.filters")
        .filter("meevoPhoneNumberFormat", meevoPhoneNumberFormatFilter);
}
